// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"631":"8d38157a","770":"4648a8fb"}[chunkId] + ".chunk.css";
};